import gql from "graphql-tag";

export const DEVICE_TOKEN = {
    query: gql`
        mutation deviceToken(
            $app: String!
            $device: String!
            $domain: String!
            $language: LanguageCode
            $chainRef: ID!
        ) {
            deviceToken(app: $app, device: $device, domain: $domain, language: $language, chainRef: $chainRef) {
                token
            }
        }
    `,
    defaultVars: {
        domain: "app-test",
        language: "en",
        chainRef: "",
    },
};
